import { render } from "./RankPrivilege.vue?vue&type=template&id=17bf8b3a&scoped=true"
import script from "./RankPrivilege.vue?vue&type=script&lang=js"
export * from "./RankPrivilege.vue?vue&type=script&lang=js"

import "./RankPrivilege.vue?vue&type=style&index=0&id=17bf8b3a&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bf8b3a"]])

export default __exports__